import { AppStoreModule } from './store/store.module';
import { CoreModule } from '../core/core.module';
import { NgModule } from '@angular/core';
import { OAuthenticationService } from './authentication/oauthentication.service';
import { PaginationComponent } from './components/pagination/pagination.component';
import { GenericGridComponent } from './components/generic-grid/generic-grid.component';
import { ToastComponent } from './components/toast/toast.component';
import { BadgeComponent } from './components/badge/badge/badge.component';
import { MenuDropdownComponent } from './components/menu-dropdown/menu-dropdown.component';
import { CustomActionsFlowComponent } from './components/custom-actions-flow/custom-actions-flow.component';
import { DocumentSubheaderComponent } from './components/document-subheader/document-subheader.component';
import { ListSubheaderComponent } from './components/list-subheader/list-subheader.component';
import { FavoriteSaveComponent } from './components/favorite-save/favorite-save.component';
import { SearchBarBadgeComponent } from './components/search-bar-badge/search-bar-badge.component';
import { SearchCustomFilterComponent } from './components/search-custom-filter/search-custom-filter.component';
import {
  ButtonSubHeaderPipe,
  ButtonTypePipe,
} from './pipe/button.subheader.pipe';
import { RouterModule } from '@angular/router';
import { CommentPanelComponent } from './components/comment/comment-panel/comment-panel.component';
import { CommentAddComponent } from './components/comment/comment-add/comment-add.component';
import { CommentComponent } from './components/comment/comment/comment.component';
import { CommentNoneComponent } from './components/comment/comment-none/comment-none.component';
import { FriendlyDatePipe } from './pipe/friendly-date.pipe';
import { BadgeListComponent } from './components/badge/badge-list/badge-list.component';
import { ErrorModule } from './error';
import { DashboardComponent } from './components/dashboard/dashboard/dashboard.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { KpiComponent } from './components/kpi/kpi.component';
import { DashboardSubheaderComponent } from './components/dashboard-subheader/dashboard-subheader.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { AddressComponent } from './components/address/address.component';
import { IbanPipe } from './pipe/iban.pipe';
import { IbanComponent } from './components/iban/iban.component';
import { PhoneNumberComponent } from './components/phone-number/phone-number.component';
import { PhoneNumberPipe } from './pipe/phone-number.pipe';
import { FullPathImagePipe } from './pipe/full-path-image.pipe';
import { TypeaheadComponent } from './components/typeahead/typeahead.component';
import { ModalContentComponent } from './components/modal-content/modal-content.component';
import { ActionsComponent } from './components/actions/actions.component';
import { FormAccessibleDirective } from './directives/form-accessible.directive';
import { CategoryChoiceComponent } from './components/category-choice/category-choice.component';
import { FormValidationMessageComponent } from './components/form-validation-message/form-validation-message.component';
import { CheckFormFieldValidityDirective } from './directives/check-form-field-validity.directive';
import { FormHasUnsavedDataDirective } from './directives/form-has-unsaved-data.directive';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { GroupByPipe } from './pipe/group-by.pipe';
import { IbanValidatorDirective } from './directives/iban-validator.directive';
import { SearchFiltersDropdownComponent } from './components/search-filters-dropdown/search-filters-dropdown.component';
import { ToastValidationComponent } from './components/toast-validation/toast-validation.component';
import { ToastValidationContentComponent } from './components/toast-validation/toast-validation-content/toast-validation-content.component';
import { ToastCssPipe } from './pipe/toast-css.pipe';
import { PaginationLabelPipe } from './components/pagination/paginationLabel.pipe';
import { SmartActionsComponent } from './components/smart-actions/smart-actions.component';
import { KanbanViewComponent } from './components/kanban-view/kanban-view.component';
import { FormattedDomainPipe } from './components/search-bar-badge/formatted-domain.pipe';
import { IsDomainActivePipe } from './components/search-filters-dropdown/is-domain-active.pipe';
import { IsBuiltInActivePipe } from './components/search-filters-dropdown/is-built-in-active.pipe';
import { SmartActionsLeadComponent } from './components/smart-actions-lead/smart-actions-lead.component';
import { CardActivePipe } from './pipe/card-active.pipe';
import { BankAccountComponent } from './components/bank-account-edit/bank-account.component';
import { AddressEditComponent } from './components/address-edit/address-edit.component';
import { MailToLinkComponent } from './components/mail-to-link/mail-to-link.component';
import { DocumentComponent } from './components/document/document/document.component';
import { DocumentPanelVerticalComponent } from './components/document/document-panel-vertical/document-panel-vertical.component';
import { DocumentAddComponent } from './components/document/document-add/document-add.component';
import { FileSizePipe } from './pipe/file-size.pipe';
import { HistoryPanelComponent } from './components/history/history-panel/history-panel.component';
import { IsHistoryTypeActivePipe } from './components/history/is-history-type-active.pipe';
import { ComparatorSubheaderComponent } from './components/comparator-subheader/comparator-subheader.component';
import { LeadQuotesComponent } from './components/lead-quotes/lead-quotes.component';
import { DocumentRequestComponent } from './components/document/not-used/document-request/document-request.component';
import { HistoryDocumentRequestCardComponent } from './components/document/history/history-document-request-card/history-document-request-card.component';
import { WholeNumberPipe } from './pipe/whole-number.pipe';
import { DecimalNumberPipe } from './pipe/decimal-number.pipe';
import { QuoteArrayCheckedPipe } from './components/lead-quotes/quote-array-checked.pipe';
import { SelectedQuoteCountPipe } from './components/lead-quotes/selected-quote-count.pipe';
import { ListSubheaderEmptyComponent } from './components/empty/list-subheader-empty/list-subheader-empty.component';
import { KanbanViewEmptyComponent } from './components/empty/kanban-view-empty/kanban-view-empty.component';
import { FirstLetterToUppercasePipe } from './pipe/first-letter-to-uppercase.pipe';
import { LoaderComponent } from './components/loader/loader.component';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { DataListingProviderComponent } from './components/data-listing-provider/data-listing-provider.component';
import { ViewTypePipe } from './pipe/viewType.pipe';
import { ProductCategoryEditComponent } from './components/product-category-edit/product-category-edit.component';
import { AvatarEditComponent } from './components/avatar-edit/avatar-edit.component';
import { DocumentCardComponent } from './components/document/document-card/document-card.component';
import { DocumentFormContentComponent } from './components/document/document-form-content/document-form-content.component';
import { AccountMoveAddContentComponent } from './components/account-moves/account-move-add-content/account-move-add-content.component';
import { AccountMoveAssignContentComponent } from './components/account-moves/account-move-assign-content/account-move-assign-content.component';
import { AccountMoveAssignDetailsContentComponent } from './components/account-moves/account-move-assign-details-content/account-move-assign-details-content.component';
import { KanbanViewContactComponent } from '../features/contacts/contact/kanban-view-contact/kanban-view-contact.component';
import { KanbanViewLeadComponent } from '../features/crm/lead/kanban-view-lead/kanban-view-lead.component';
import { CustomActionsFlowContractComponent } from '../features/crm/contract/contract-details/custom-actions-flow-contract/custom-actions-flow-contract.component';
import { CustomActionsFlowLeadComponent } from '../features/crm/lead/lead-details/custom-actions-flow-lead/custom-actions-flow-lead.component';
import { CustomActionsFlowGlossaryComponent } from '../features/cms/glossary/glossary-detail/custom-actions-flow-glossary/custom-actions-flow-glossary.component';
import { CustomActionsFlowArticleComponent } from '../features/cms/article/article-detail/custom-actions-flow-article/custom-actions-flow-article.component';
import { KanbanViewContractComponent } from '../features/crm/contract/kanban-view-contract/kanban-view-contract.component';
import { KanbanViewContactsComponent } from '../features/contacts/contact/kanban-view-contacts/kanban-view-contacts.component';
import { KanbanViewEmployeeComponent } from '../features/human-resources/employee/kanban-view-employee/kanban-view-employee.component';
import { CustomActionsFlowUserComponent } from '../features/configuration/user/user/user-details/custom-actions-flow-user/custom-actions-flow-user.component';
import { KanbanViewDocumentsComponent } from '../features/documents/document/kanban-view-documents/kanban-view-documents.component';
import { CustomActionsFlowActivityComponent } from '../features/crm/activity/activity-details/custom-actions-flow-activity/custom-actions-flow-activity.component';
import { PaymentAddContentComponent } from './components/account-moves/payment-add-content/payment-add-content.component';
import { KanbanViewDocumentComponent } from '../features/documents/document/kanban-view-document/kanban-view-document.component';
import { GenericFileInputComponent } from './components/generic-file-input/generic-file-input.component';
import { SlipAddContentComponent } from './components/account-moves/slip-add-content/slip-add-content.component';
import { AccountMoveAssignRepaymentContentComponent } from './components/account-moves/account-move-assign-repayment-content/account-move-assign-repayment-content.component';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ShowJournalAndTruncatePipe } from './pipe/accounting/show-journal-and-truncate.pipe';
import { AccountMoveAssignSlipContentComponent } from './components/account-moves/account-move-assign-slip-content/account-move-assign-slip-content.component';
import { ShowPaymentAndTruncatePipe } from './pipe/accounting/show-payment-and-truncate.pipe';
import { ShowRepaymentAndTruncatePipe } from './pipe/accounting/show-repayment-and-truncate.pipe';
import { ShowInvoiceAndTruncatePipe } from './pipe/accounting/show-invoice-and-truncate.pipe';
import { AccountMovesAmountPipe } from './components/account-moves/account-move-assign-details-content/accountmoves-amount.pipe';
import { PeriodPipe } from './pipe/accounting/period.pipe';
import { AccountMoveAssignSlipDetailsContentComponent } from './components/account-moves/account-move-assign-slip-details-content/account-move-assign-slip-details-content.component';
import { UpdatePasswordAccountComponent } from './components/scraper/update-password-account/update-password-account.component';
import { LinkToComponent } from './components/link-to/link-to.component';
import { JoinAllArrayValuesPipe } from './pipe/join-all-array-values.pipe';
import { ShowSignValueTypePipe } from './pipe/show-sign-value-type.pipe';
import { DocumentPanelHorizontalComponent } from './components/document/document-panel-horizontal/document-panel-horizontal.component';
import { HorizontalClassPipe } from './components/document/document-card/vertical-class.pipe';
import { CommissionPlanRuleDetailsCommissionRateComponent } from './components/commission-plan-rule-details-commission-rate/commission-plan-rule-details-commission-rate.component';
import { ApplicationFeeRuleDetailsApplicationFeeComponent } from './components/application-fee-rule-details-application-fee/application-fee-rule-details-application-fee.component';
import { AccountFormContentComponent } from './components/account-form-content/account-form-content.component';
import { TabDocumentsComponent } from './components/document/tab/tab-documents/tab-documents.component';
import { DocumentUploadDragAndDropComponent } from './components/document/tab/document-upload-drag-and-drop/document-upload-drag-and-drop.component';
import { ActionLinkComponent } from './components/generic-grid/action-link/action-link.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { AccountMovePeriodPipe } from './pipe/accounting/account-move-period.pipe';
import { ColoredAmountComponent } from './components/colored-amount/colored-amount.component';
import { SortByPipe } from './pipe/sort-by.pipe';
import { SalesObjectivesRuleFormContentComponent } from './components/sales-objectives/sales-objectives-rule-form-content/sales-objectives-rule-form-content.component';
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { ToLocalTimePipe } from './pipe/local-time/to-local-time.pipe';
import { HRefGridComponent } from './components/generic-grid/href-grid/href-grid-component';
import { IsPropertyActivePipe } from './components/search-filters-dropdown/is-property-active.pipe';
import { IsOneItemInPropertyActivePipe } from './components/search-filters-dropdown/is-one-item-in-property-active.pipe';
import { AccountMoveAddInvoiceExtendedContentComponent } from './components/account-moves/account-move-add-invoice-extended-content/account-move-add-invoice-extended-content.component';
import { DocumentLinkComponent } from './components/generic-grid/document-link/document-link.component';
import { AccountMoveIssuingDetailsComponent } from './components/generic-grid/account-move-issuing-details/account-move-issuing-details.component';
import { AccountMovesTabComponent } from './components/account-moves/account-moves-tab/account-moves-tab.component';
import { IconComponent } from './components/generic-grid/icon/icon.component';
import { HeaderTooltipComponent } from './components/generic-grid/header-tooltip/header-tooltip.component';
import { TitleTooltipComponent } from './components/generic-grid/title-tooltip/title-tooltip.component';
import { ActionsGroupComponent } from './components/actions-group/actions-group.component';
import { ReplaceActionCustomParameterByValuePipe } from './components/actions-group/replace-action-custom-parameter-by-value.pipe';
import { JsonParsePipe } from './pipe/json-parse.pipe';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { TotalCountPipe } from './components/dashboard-subheader/total-count.pipe';
import { OffcanvasTriggerComponent } from './components/generic-grid/offcanvas-trigger/offcanvas-trigger.component';
import { OffcanvasContentComponent } from './components/offcanvas-content/offcanvas-content.component';
import { SuccessComponent } from './components/generic-grid/success/success.component';
import { DisplayLikeCodeComponent } from './components/generic-grid/offcanvas/display-like-code/display-like-code.component';
import { DisplayLikeQuoteComponent } from './components/generic-grid/offcanvas/display-like-quote/display-like-quote.component';
import { SmartActionLinkComponent } from './components/generic-grid/smart-action-link/smart-action-link.component';
import { TabDocumentRequestCardComponent } from './components/document/tab/tab-document-request-card/tab-document-request-card.component';
import { CustomActionsAlertComponent } from './components/custom-actions-alert/custom-actions-alert.component';

@NgModule({
  declarations: [
    PaginationComponent,
    GenericGridComponent,
    ToastComponent,
    BadgeComponent,
    BadgeListComponent,
    MenuDropdownComponent,
    CustomActionsFlowComponent,
    CustomActionsFlowContractComponent,
    CustomActionsFlowLeadComponent,
    CustomActionsFlowGlossaryComponent,
    CustomActionsFlowArticleComponent,
    DocumentSubheaderComponent,
    ListSubheaderComponent,
    FavoriteSaveComponent,
    SearchBarBadgeComponent,
    SearchBarComponent,
    SearchCustomFilterComponent,
    SearchFiltersDropdownComponent,
    ButtonSubHeaderPipe,
    CommentPanelComponent,
    CommentAddComponent,
    CommentComponent,
    CommentNoneComponent,
    FriendlyDatePipe,
    DashboardComponent,
    KpiComponent,
    DashboardSubheaderComponent,
    ButtonTypePipe,
    BreadcrumbComponent,
    AddressComponent,
    IbanPipe,
    IbanComponent,
    PhoneNumberComponent,
    PhoneNumberPipe,
    FullPathImagePipe,
    TypeaheadComponent,
    ModalContentComponent,
    ActionsComponent,
    FormAccessibleDirective,
    CategoryChoiceComponent,
    FormValidationMessageComponent,
    CheckFormFieldValidityDirective,
    FormHasUnsavedDataDirective,
    ConfirmationComponent,
    GroupByPipe,
    IbanValidatorDirective,
    ToastValidationComponent,
    ToastValidationContentComponent,
    ToastCssPipe,
    FormattedDomainPipe,
    PaginationLabelPipe,
    SmartActionsComponent,
    KanbanViewComponent,
    KanbanViewContactComponent,
    KanbanViewLeadComponent,
    KanbanViewContractComponent,
    IsDomainActivePipe,
    IsBuiltInActivePipe,
    SmartActionsLeadComponent,
    KanbanViewContactsComponent,
    KanbanViewEmployeeComponent,
    CardActivePipe,
    CustomActionsFlowUserComponent,
    BankAccountComponent,
    AddressEditComponent,
    MailToLinkComponent,
    DocumentComponent,
    DocumentPanelVerticalComponent,
    DocumentAddComponent,
    KanbanViewDocumentsComponent,
    KanbanViewDocumentComponent,
    FileSizePipe,
    HistoryPanelComponent,
    IsHistoryTypeActivePipe,
    ComparatorSubheaderComponent,
    DocumentRequestComponent,
    LeadQuotesComponent,
    HistoryDocumentRequestCardComponent,
    WholeNumberPipe,
    DecimalNumberPipe,
    QuoteArrayCheckedPipe,
    SelectedQuoteCountPipe,
    KanbanViewEmptyComponent,
    ListSubheaderEmptyComponent,
    FirstLetterToUppercasePipe,
    LoaderComponent,
    MultiSelectDropdownComponent,
    DataListingProviderComponent,
    ViewTypePipe,
    ProductCategoryEditComponent,
    AvatarEditComponent,
    CustomActionsFlowActivityComponent,
    DocumentCardComponent,
    DocumentFormContentComponent,
    PaymentAddContentComponent,
    AccountMoveAddContentComponent,
    AccountMoveAssignContentComponent,
    AccountMoveAssignDetailsContentComponent,
    GenericFileInputComponent,
    SlipAddContentComponent,
    AccountMoveAssignRepaymentContentComponent,
    AccountMoveAssignSlipContentComponent,
    ShowPaymentAndTruncatePipe,
    ShowRepaymentAndTruncatePipe,
    ShowInvoiceAndTruncatePipe,
    ShowJournalAndTruncatePipe,
    AccountMovesAmountPipe,
    PeriodPipe,
    AccountMoveAssignSlipDetailsContentComponent,
    UpdatePasswordAccountComponent,
    LinkToComponent,
    JoinAllArrayValuesPipe,
    ShowSignValueTypePipe,
    DocumentPanelHorizontalComponent,
    HorizontalClassPipe,
    CommissionPlanRuleDetailsCommissionRateComponent,
    ApplicationFeeRuleDetailsApplicationFeeComponent,
    AccountFormContentComponent,
    TabDocumentsComponent,
    DocumentUploadDragAndDropComponent,
    ActionLinkComponent,
    ConfirmationDialogComponent,
    AccountMovePeriodPipe,
    ColoredAmountComponent,
    SortByPipe,
    SalesObjectivesRuleFormContentComponent,
    DropdownMenuComponent,
    HRefGridComponent,
    IsPropertyActivePipe,
    IsOneItemInPropertyActivePipe,
    AccountMoveAddInvoiceExtendedContentComponent,
    DocumentLinkComponent,
    AccountMoveIssuingDetailsComponent,
    AccountMovesTabComponent,
    IconComponent,
    HeaderTooltipComponent,
    TitleTooltipComponent,
    ActionsGroupComponent,
    ReplaceActionCustomParameterByValuePipe,
    JsonParsePipe,
    OffcanvasTriggerComponent,
    OffcanvasContentComponent,
    SuccessComponent,
    DisplayLikeCodeComponent,
    DisplayLikeQuoteComponent,
    SmartActionLinkComponent,
    TabDocumentRequestCardComponent,
    CustomActionsAlertComponent,
  ],
  exports: [
    AppStoreModule,
    CoreModule,
    GenericGridComponent,
    PaginationComponent,
    ToastComponent,
    BadgeComponent,
    BadgeListComponent,
    MenuDropdownComponent,
    CustomActionsFlowComponent,
    CustomActionsFlowContractComponent,
    CustomActionsFlowLeadComponent,
    CustomActionsFlowGlossaryComponent,
    CustomActionsFlowArticleComponent,
    DocumentSubheaderComponent,
    ListSubheaderComponent,
    FavoriteSaveComponent,
    SearchBarBadgeComponent,
    SearchBarComponent,
    SearchCustomFilterComponent,
    SearchFiltersDropdownComponent,
    ButtonSubHeaderPipe,
    CommentPanelComponent,
    CommentAddComponent,
    CommentComponent,
    CommentNoneComponent,
    FriendlyDatePipe,
    DashboardComponent,
    KpiComponent,
    DashboardSubheaderComponent,
    ButtonTypePipe,
    BreadcrumbComponent,
    AddressComponent,
    IbanPipe,
    IbanComponent,
    PhoneNumberComponent,
    PhoneNumberPipe,
    FullPathImagePipe,
    TypeaheadComponent,
    ModalContentComponent,
    ActionsComponent,
    FormAccessibleDirective,
    CategoryChoiceComponent,
    FormValidationMessageComponent,
    CheckFormFieldValidityDirective,
    FormHasUnsavedDataDirective,
    ConfirmationComponent,
    GroupByPipe,
    IbanValidatorDirective,
    ToastValidationComponent,
    SmartActionsComponent,
    KanbanViewComponent,
    KanbanViewContactComponent,
    KanbanViewContractComponent,
    KanbanViewLeadComponent,
    SmartActionsLeadComponent,
    KanbanViewContactsComponent,
    KanbanViewEmployeeComponent,
    CardActivePipe,
    CustomActionsFlowUserComponent,
    AddressEditComponent,
    MailToLinkComponent,
    KanbanViewDocumentsComponent,
    KanbanViewDocumentComponent,
    FileSizePipe,
    HistoryPanelComponent,
    IsHistoryTypeActivePipe,
    ComparatorSubheaderComponent,
    LeadQuotesComponent,
    DocumentRequestComponent,
    WholeNumberPipe,
    DecimalNumberPipe,
    QuoteArrayCheckedPipe,
    SelectedQuoteCountPipe,
    KanbanViewEmptyComponent,
    ListSubheaderEmptyComponent,
    FirstLetterToUppercasePipe,
    LoaderComponent,
    MultiSelectDropdownComponent,
    DataListingProviderComponent,
    ViewTypePipe,
    ProductCategoryEditComponent,
    AvatarEditComponent,
    CustomActionsFlowActivityComponent,
    BankAccountComponent,
    DocumentCardComponent,
    DocumentFormContentComponent,
    PaymentAddContentComponent,
    AccountMovesTabComponent,
    AccountMoveAddContentComponent,
    GenericFileInputComponent,
    AccountMoveAssignRepaymentContentComponent,
    ShowPaymentAndTruncatePipe,
    ShowRepaymentAndTruncatePipe,
    ShowInvoiceAndTruncatePipe,
    ShowJournalAndTruncatePipe,
    AccountMovesAmountPipe,
    LinkToComponent,
    FullPathImagePipe,
    DocumentPanelVerticalComponent,
    DocumentAddComponent,
    JoinAllArrayValuesPipe,
    ShowSignValueTypePipe,
    DocumentPanelHorizontalComponent,
    HorizontalClassPipe,
    CommissionPlanRuleDetailsCommissionRateComponent,
    ApplicationFeeRuleDetailsApplicationFeeComponent,
    AccountFormContentComponent,
    TabDocumentsComponent,
    DocumentUploadDragAndDropComponent,
    ConfirmationDialogComponent,
    AccountMovePeriodPipe,
    HistoryDocumentRequestCardComponent,
    SortByPipe,
    SalesObjectivesRuleFormContentComponent,
    DropdownMenuComponent,
    IsPropertyActivePipe,
    IsOneItemInPropertyActivePipe,
    ColoredAmountComponent,
    ActionsGroupComponent,
    TabDocumentRequestCardComponent,
    CustomActionsAlertComponent,
  ],
  imports: [
    CoreModule,
    AppStoreModule,
    RouterModule,
    ErrorModule,
    ToLocalTimePipe,
    SafeHtmlPipe,
    TotalCountPipe,
  ],
  providers: [
    // OAuthenticationService removed to avoid multiple instances
    CurrencyPipe,
    DatePipe,
    ShowSignValueTypePipe,
    ToLocalTimePipe,
  ],
})
export class SharedModule {}
